import React        from 'react';
import PropTypes    from 'prop-types';
import Flux         from '../../../flux/Flux';
import ReloadHelper from '../../../utils/ReloadHelper';
import Translations from '../../../utils/Translations';
import UrlBuilder   from '../../../utils/UrlBuilder';

class AlbumModelName extends React.Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	/**
	 * @param {Event} e
	 */
	onClick(e) {
		ReloadHelper.reloadWithPjax(e.target.href, e);
	}

	render() {
		const {actorName, contestDetailsUrl, baseClassName} = this.props;
		return (
				<div className={baseClassName + '-actors'}>
					{
						actorName &&
						<a className={baseClassName + '-actors-link'} href={UrlBuilder.buildActorProfileUrl(actorName)}
						   title={actorName}
						   onClick={this.onClick}
						>{actorName}
						</a>
					}
					{
						contestDetailsUrl && Flux.Guest.isLoggedIn() &&
						<div className={baseClassName + '-actors-contest-details'}>
							<a className={baseClassName + '-actors-contest-details-link'}
							   href={contestDetailsUrl}
							   onClick={this.onClick}
							>{Translations.get('MoreVideosFromContest')} <i className="icon -icon-single-arrow-right-line" />
							</a>
						</div>
					}
				</div>
		);
	}
}

AlbumModelName.propTypes = {
	baseClassName:     PropTypes.string,
	actorName:         PropTypes.string,
	contestDetailsUrl: PropTypes.string,
};

AlbumModelName.defaultProps = {
    baseClassName:   'profile-video-details--description-complex',
};

export default AlbumModelName;
